import React from "react";

/**
 * Typing indicator for one or more users in the open chat.
 * @param {Object} props
 * @param {Array<{ user_id: number, user_name?: string }>} props.typingUsers
 * @returns {JSX.Element | null}
 */
function TypingIndicator({ typingUsers }) {
  if (!typingUsers || typingUsers.length === 0) return null;

  const names = typingUsers
    .map((u) => u.user_name || "Someone")
    .filter(Boolean);
  let label = "Someone is typing…";
  if (names.length === 1) {
    label = `${names[0]} is typing…`;
  } else if (names.length === 2) {
    label = `${names[0]} and ${names[1]} are typing…`;
  } else if (names.length > 2) {
    label = `${names[0]} and ${names.length - 1} others are typing…`;
  }

  return (
    <div className="flex items-center px-3 pb-1 text-sm text-text-muted">
      <div className="mr-2 flex space-x-1">
        <div className="h-2 w-2 rounded-full bg-ui-muted-foreground/50 animate-bounce" />
        <div
          className="h-2 w-2 rounded-full bg-ui-muted-foreground/50 animate-bounce"
          style={{ animationDelay: "0.1s" }}
        />
        <div
          className="h-2 w-2 rounded-full bg-ui-muted-foreground/50 animate-bounce"
          style={{ animationDelay: "0.2s" }}
        />
      </div>
      <span>{label}</span>
    </div>
  );
}

export default TypingIndicator;
